import { render, staticRenderFns } from "./GoalMetrics.vue?vue&type=template&id=5f0ae7a2&scoped=true&"
import script from "./GoalMetrics.vue?vue&type=script&lang=js&"
export * from "./GoalMetrics.vue?vue&type=script&lang=js&"
import style0 from "./GoalMetrics.vue?vue&type=style&index=0&id=5f0ae7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ae7a2",
  null
  
)

export default component.exports